import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class GeographyInfoBus 
{
    constructor(data: GeographyInfoBus = null) {
        if (data !== undefined && data !== null) {
            Object.assign(this, data);
            this.insertDt = DateFunctions.getDate(this.insertDt);
            this.updateDt = DateFunctions.getDate(this.updateDt);
        }
    }
    set(geographyId: any,
        addressName: string,
        addressLine1: string,
        addressLine2: string,
        city: string,
        stateProvince: string,
        countryCd: string,
        county: string,
        postalCode: string,
        geographyTypeId: number = 0) {

        this.geographyId = geographyId;
        this.addressName = addressName;
        this.addressLine1 = addressLine1;
        this.addressLine2 = addressLine2;
        this.city = city;
        this.stateProvince = stateProvince;
        this.countryCd = countryCd;
        this.county = county;
        this.postalCode = postalCode;
        this.geographyTypeId = geographyTypeId;
    }
 geographyId: any;
 geographyTypeId: number;
 addressName: string;
 addressLine1: string;
 addressLine2: string;
 addressLine3: string;
 addressLine4: string;
 city: string;
 stateProvince: string;
 countryCd: string;
 county: string;
 postalCode: string;
 insertDt: Date;
 insertUserId: any;
 updateDt: Date;
    updateUserId: any; 
    get getFormattedAddressString() { return `${this.addressName}\r\n` +
                                             `${this.addressLine1}\r\n` +
                                             `${this.addressLine2 ? this.addressLine2 + '\r\n' : ''}` +  // include addressLine2 only if it's not empty
                                             `${this.city}, ${this.stateProvince} ${this.postalCode}\r\n`;
};
}